import axios from "../../utils/axios";
import type { SubjectDTO } from "../types/lookupDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const fetchAllSubjects = () => axios.get<SubjectDTO[]>(`${apiUrl}/Subject/GetAll`);

const subjectService = {
  fetchAllSubjects,
};

export default subjectService;
